// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"676b9ed8","641":"920fbf59"}[chunkId] + ".chunk.js";
};